import React from 'react';
import { Box } from '@mui/material';
import { useLoadingActivities } from '@client/hooks/use-is-loading.hook';
import { Tooltip } from '@ui/Tooltip';
import { DotLoader } from '@ui/DotLoader';
import { APP_WORK_STATUS_NAME } from './project-selector-toggle.constants';

/** Keep background work visible without replacing the navigation logo. */
export const AppWorkIndicator = () => {
  const activities = useLoadingActivities();
  const loading = activities.length > 0;
  return (
    <Tooltip title={activities.join(' · ')} placement="bottom" describeChild>
      <Box
        role="status"
        aria-label={APP_WORK_STATUS_NAME}
        aria-busy={loading}
        sx={{
          width: 24,
          height: 8,
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          color: 'rgba(0,0,0,0.45)',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 1,
          opacity: loading ? 1 : 0,
          // Periods sit below the text box's center; align their visible dots
          // with the neighboring 8 px undo/redo icons.
          '& > span': { transform: 'translateY(-0.3em)' },
        }}
      >
        {loading && <DotLoader initialDots={0} />}
      </Box>
    </Tooltip>
  );
};
